/**
 * Converte uma string DATEONLY ('AAAA-MM-DD', sem horário) do backend para um Date local,
 * sem passar por `new Date(iso)` — que interpreta a string como meia-noite UTC e desloca a
 * data em 1 dia para trás em fusos negativos (ex: Brasil). Mesmo bug já documentado no
 * módulo Calendário (`EventoModal.tsx`, `parseInputDateLocal`), aqui como util compartilhado.
 */
export function parseDateOnly(iso: string): Date {
  const [ano, mes, dia] = iso.split('-').map(Number);
  return new Date(ano, mes - 1, dia);
}

/**
 * Formata um valor DATEONLY do backend ("AAAA-MM-DD" ou "AAAA-MM-DDTHH:mm:ss.sssZ") como
 * dd/MM/aaaa, lendo os componentes ano/mês/dia direto da string — sem passar por `new Date()`,
 * que interpreta "AAAA-MM-DD" como meia-noite UTC e, em fusos negativos (Brasil, UTC-3), formata
 * um dia antes do valor real ao usar getters locais (`format`/`toLocaleDateString`).
 */
export function formatDateOnly(value?: string | null): string {
  if (!value) return '';
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (!match) return '';
  const [, year, month, day] = match;
  return `${day}/${month}/${year}`;
}

/**
 * Parseia um valor DATEONLY ("AAAA-MM-DD...") como meia-noite LOCAL, para uso em aritmética de
 * datas (diferença de dias etc.) — evita o mesmo problema de `new Date(iso)` interpretar como
 * UTC meia-noite e voltar um dia em fusos negativos (Brasil, UTC-3).
 */
export function parseDateOnlyLocal(value?: string | null): Date | null {
  if (!value) return null;
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (!match) return null;
  const [, year, month, day] = match;
  return new Date(Number(year), Number(month) - 1, Number(day));
}
